
// Versioned cross-origin interface for the Shopify host. Never accepts arbitrary frames or origins.
class PinballBridge {
  constructor(input) {
    this.input = input;
    this.origin = null;
    this.lastContact = 0;
    const localFile = window.location.protocol === 'file:';
    const ownOrigin = localFile ? 'null' : window.location.origin;
    this.token = new URLSearchParams(window.location.hash.slice(1)).get('review-channel');
    const validToken = /^[a-f0-9]{48}$/.test(this.token || '');
    this.allowedOrigins = new Set(validToken && (ownOrigin !== 'null' || localFile) ? [ownOrigin] : []);
    this.targetOrigin = localFile ? '*' : ownOrigin;
    this.receive = event => {
      if (window.parent === window || event.source !== window.parent || !this.allowedOrigins.has(event.origin)) return;
      const data = event.data;
      if (!data || data.token !== this.token || typeof data !== 'object' || data.channel !== 'xarcade-pinball' || data.version !== 1) return;
      if (data.type === 'connect') { this.origin = event.origin; this.lastContact = performance.now(); this.sendStatus(); return; }
      if (event.origin !== this.origin) return;
      if (data.type === 'host-visibility' && typeof data.visible === 'boolean') { input.hooks.onHostVisibility?.(data.visible); this.sendStatus(); return; }
      if (data.type === 'heartbeat') { this.lastContact = performance.now(); return; }
      if (data.type === 'release-all') { input.releaseRemote(); this.sendStatus(); return; }
      if (data.type !== 'control') return;
      if (Object.hasOwn(DEFAULT_BINDS,data.action) && data.pressed === true) input.hooks.onHostFocus?.();
      if (input.setRemoteAction(data.action, data.pressed)) { this.lastContact = performance.now(); this.sendStatus(); }
    };
    addEventListener('message', this.receive);
    this.lease = setInterval(() => {
      if (input.remote.size && performance.now() - this.lastContact > 1500) {input.releaseRemote();this.sendStatus();}
    }, 250);
    addEventListener('pagehide', () => { input.releaseRemote();clearInterval(this.lease);removeEventListener('message', this.receive); });
  }
  sendStatus() {
    if (!this.origin) return;
    window.parent.postMessage({channel:'xarcade-pinball',version:1,token:this.token,type:'state',
      hostVisible:this.input.hooks.isHostVisible?.() !== false,
      ready:GameLoading.ready, acceptingInput:GameLoading.ready && !this.input.hooks.inputBlocked?.() && (!this.input.hooks.isPaused?.() || this.input.hooks.hostCanResume?.()),
      controls:{...this.input.active}}, this.targetOrigin);
  }
}
